/* src/app/global/components/global-help/global-help-popup/global-help-popup.component.scss */
:host .cw-dialog {
  background-color: var(--color-primary-light);
  height: calc(100% + 48px);
  margin: 0;
  overflow-y: hidden;
}
:host .cw-dialog-content {
  height: 100%;
}
:host .cw-dialog-details,
:host .cw-flex-row {
  height: 100%;
}
:host .help-details {
  flex: 2;
  height: 100%;
  overflow-y: hidden;
}
:host .help-menu {
  border-right: 1px solid var(--color-primary-lighter);
  flex: 1;
  overflow-y: hidden;
}
/*# sourceMappingURL=global-help-popup.component.css.map */
